import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiCheck, FiShare2, FiHeart, FiX } = FiIcons;

const CampaignSuccessBanner = ({ campaign, result, onClose }) => {
  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: campaign.title,
        text: `Help support: ${campaign.title}`,
        url: window.location.href,
      }).catch(() => {});
    } else {
      navigator.clipboard.writeText(window.location.href).catch(() => {});
    }
  };

  return (
    <div className="bg-white rounded-[40px] border border-brand-dark shadow-2xl overflow-hidden">
      {/* Header */}
      <div className="bg-gradient-to-r from-green-600 to-emerald-500 p-8 text-center relative">
        <button onClick={onClose} className="absolute top-4 right-4 p-2 hover:bg-white/10 rounded-full text-white/60 hover:text-white transition-colors">
          <SafeIcon icon={FiX} className="w-5 h-5" />
        </button>
        <motion.div initial={{ scale: 0 }} animate={{ scale: 1 }} transition={{ type: 'spring', stiffness: 200 }}
          className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-xl">
          <SafeIcon icon={FiCheck} className="w-10 h-10 text-green-600" />
        </motion.div>
        <h2 className="font-serif text-2xl text-white mb-1">Campaign Launched!</h2>
        <p className="text-white/70 text-sm">Your donation campaign is now live.</p>
      </div>

      <div className="p-8 space-y-5">
        <div className="bg-brand-light/50 border border-brand-dark rounded-3xl divide-y divide-brand-dark overflow-hidden">
          {[
            ['Campaign',    campaign.title],
            ['Goal',        `$${Number(campaign.goal_amount).toLocaleString()}`],
            ['Deadline',    campaign.deadline],
            ['Beneficiary', campaign.beneficiary_name],
          ].map(([k, v]) => (
            <div key={k} className="flex justify-between items-center px-5 py-3">
              <span className="text-[10px] font-black uppercase tracking-widest text-text-muted">{k}</span>
              <span className="text-sm font-bold text-accent-navy">{v}</span>
            </div>
          ))}
        </div>

        <div className="flex gap-3">
          <button onClick={handleShare}
            className="flex-1 flex items-center justify-center gap-2 py-4 bg-accent-navy text-white rounded-2xl text-[10px] font-black uppercase tracking-widest hover:bg-accent-navy/90 transition-all">
            <SafeIcon icon={FiShare2} className="w-4 h-4" /> Share Campaign
          </button>
          <button onClick={onClose}
            className="flex-1 flex items-center justify-center gap-2 py-4 bg-accent-gold text-white rounded-2xl text-[10px] font-black uppercase tracking-widest hover:bg-accent-gold/90 transition-all">
            <SafeIcon icon={FiHeart} className="w-4 h-4" /> Done
          </button>
        </div>

        <p className="text-center text-[10px] text-text-muted">
          Your campaign will appear on the memorial page immediately. A super admin may feature it on the home page.
        </p>
      </div>
    </div>
  );
};

export default CampaignSuccessBanner;